"use client"

import { useState, useRef, useEffect } from "react"
import { BiDotsVerticalRounded } from "react-icons/bi"

export default function DropdownOption({ options = [], className = "" }) {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div className={`dropdown ${className}`} ref={dropdownRef}>
      <button className="btn btn-sm px-0" type="button" onClick={() => setIsOpen(!isOpen)} aria-expanded={isOpen}>
        <BiDotsVerticalRounded className="fs-5" />
      </button>

      {isOpen && (
        <ul className="dropdown-menu dropdown-menu-end rounded-1 show position-absolute p-0 overflow-hidden" style={{ minWidth: "130px" }}>
          {options.map((option, index) => (
            <li key={index}>
              <button className={`dropdown-item d-flex align-items-center small border-bottom border-light ${option.className || ""}`}
                onClick={() => {
                  option.onClick()
                  setIsOpen(false)
                }}>
                {option.icon && <span className="me-1">{option.icon}</span>}
                {option.label}
              </button>
            </li>
          ))} 
        </ul>
      )}
    </div>

  )
}
